import moment from 'moment'
import React, { useState } from 'react'
import { Col, Row } from 'reactstrap'
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2'
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete'
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput'
import { inputStyle } from 'views/pages/manage/masters/schoolMaster/schoolInfo/constant'
import { FaCheckSquare } from 'react-icons/fa';
import { validatePincode } from './utils'
import ATimePicker from 'views/pages/manage/common/form-fields-mui/ATimePicker'
import AWeekPicker from 'views/pages/manage/common/form-fields-mui/AWeekPicker'
import { ReactComponent as CloseIcon } from "assets/img/svg/closeSquare.svg";
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function'
import { Checkbox, Dialog, FormControlLabel, Tooltip } from '@mui/material'
import ATextarea from 'views/pages/manage/common/formFeilds/customInput/ATextarea'
import AButton from 'views/pages/manage/common/form-fields-mui/AButton'
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { ReactComponent as Uparrow } from "assets/img/svg/upwardArrow.svg";
import { primaryCheckboxStyles } from 'views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant'
import StatusSyncingDropdown from './StatusSyncingDropdown'
import { getStatusCount } from './constant'
import CustomCopyToClipboard from 'views/pages/manage/common/ACopyToClipboard/CustomCopyToClipboard'
import MultiSelectCellComponentWithSearch from 'views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch'
import { maskPhoneNumber } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/paymentLink/utils'
export const DisplayViewData = ({ dataArray = [], heading, rowFormHandler = () => { }, form, setForm, isEdit, dropdown = {}, action, setOpen, toggleRequired, setOpenToggle, openToggle }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const getMultipleVal = (value, label) => {
        // return (value.map(item => (
        //     item?.label ?? item
        // ))).join(',')
        return <MultiSelectCellComponentWithSearch
            title={label}
            data={value}
            eyeIcon
        />
    }
    const formatField = (key, value) => {
  const isLinkOrUrl = /url|link/i.test(key); // Case-insensitive match

  if (isLinkOrUrl && value) {
    return (
      <div className='d-flex ellipsis-text-container'>
        <Tooltip title={value}>
          <div className='ellipsis-text-container'>
            {value}
          </div>
        </Tooltip>
        <CustomCopyToClipboard textToCopy={value} />
      </div>
    );
  }

  return value;
};

    const getFormatCol = (value = '', key,label,dataRow) => {
        console.log('dataRow',dataRow)

        return key == 'locationHistory' ?
            <AButton
                variant="link"
                size="xs"
                //disabled={rowForm?.applicationLevel === 'NO' || !params?.row?.isNew}
                onClick={
                    (e) => {
                        e.stopPropagation();
                        setOpen(true)
                    }
                }
            >
                View
            </AButton>
            : key == 'status' ?
                <div className='large-semi-bold label-color'>
                    {getStatusCount(value)}
                </div>
                : <div className='large-semi-bold label-color' style={value?.label == 'ACTIVE' ? { color: '#05945B' } : {}}>
                    {
                        Array.isArray(value)
                            ? getMultipleVal(value, label)
                            : formatField(key, dataRow?.renderData?.(value))
                                ? dataRow?.renderData?.(value?.label) || formatField(key, dataRow?.renderData?.(value))
                                : '-'
                    }
                    {/* {value?.[0]?.label??value?.label??value??'-'} */}
                </div>
    }
    const getVal = (col, index, form, setForm) => {
        const checkboxOptions = [
            {
                title: "ALC",
                onChange: (e) => {
                    e.target.checked && rowFormHandler(col?.colKey, "ALC", setForm);
                },
                checked: form?.[col?.colKey] === "ALC",
            },
            {
                title: "F+EC",
                onChange: (e) => {
                    e.target.checked && rowFormHandler(col?.colKey, "F+EC", setForm);
                },
                checked: form?.[col?.colKey] === "F+EC",
                //disabled: true,
            },
            {
                title: "None",
                onChange: (e) => {
                    e.target.checked && rowFormHandler(col?.colKey, "None", setForm);
                },
                checked: form?.[col?.colKey] === "None",
                //disabled: true,
            },
        ];
        switch (col?.colType) {
            case "input":
                return <AInput
                    key={`${index}-${col?.colKey}`} // Ensure unique key
                    type="text"
                    value={form?.[col?.colKey] || ""} // Dynamically access value
                    handler={(value) => {
                        rowFormHandler(col?.colKey, value, setForm)
                        col?.colKey == 'pincode' && validatePincode(value, setForm, dropdown)
                    }}
                    disabled={action == 'new'&&!['city','district','state','country'].includes(col?.colKey) ? false : col.disabled} // Modify if needed
                    placeholder=""
                    regex={col.regex}
                    //style={selectStyles.control}
                    rightCustomIcon={col?.colKey == 'pincode' && <FaCheckSquare style={{
                        color: (!(form?.[col?.colKey] && (form?.[col?.colKey]).length == 6 && form?.isValidPin)) ? '#D3D3D3' : '#00B0F5', backgroundColor: '#FFF', fontSize: '20px', top: '3px', right: '5px',
                        position: "absolute",
                        bottom: "0",
                        margin: "auto 0",
                        cursor: form?.[col?.colKey] && (form?.[col?.colKey]).length == 6 ? "pointer" : "not-allowed",
                    }}
                    />}
                    //onClick={()=>{validatePincode(basicForm[col?.colKey])}}
                    style={inputStyle}
                    maxLength={col?.maxLength}
                />
            // Error
            case "select":
                return <AAutoComplete
                    placeholder=""
                    currentValue={col?.colKey == 'businessAreaType' ? form?.[col?.colKey]?.[0] : form?.[col?.colKey]}
                    handleChange={(value) => {
                        col?.colKey == 'businessUnitType' ? rowFormHandler(col?.colKey, [value], setForm) : rowFormHandler(col?.colKey, value, setForm);
                        col.customHandleChange && col.customHandleChange(setForm, value);
                    }}
                    items={dropdown?.[col?.colKey]}
                    isMulti={col?.isMulti ?? false}
                    isShowCount={col?.isMulti ?? false}
                    style={{ control: inputStyle }}
                    isInputChange={true}
                    isDisabled={action == 'new' ? false : col.disabled}
                />; // Warning
            case "date":
                return <CustomDatePickerV2
                    style={{ input: inputStyle }}
                    placeHolder=""
                    value={form?.[col?.colKey]}
                    handler={(index, date) => {
                        rowFormHandler(col?.colKey, moment(date).startOf('day'), setForm)
                    }}
                    //isStartDate={true}
                    // minDate={moment(new Date(), "DD-MM-YYYY").subtract(1, "months")}
                    // maxDate={new moment(new Date())}
                    disabled={action == 'new' ? false : col.disabled}
                />
            case 'time':
                return <ATimePicker
                    timestamp={form?.[col?.colKey]}
                    handler={(time) => {
                        col?.colKey == 'startTime' ? setForm({
                            ...form,
                            [col?.colKey]: time,
                            'endTime': ''
                        }) : rowFormHandler(col?.colKey, time, setForm)
                    }}
                    disabled={col?.colKey == 'endTime' && !form?.startTime}
                    minTime={col?.colKey == 'endTime' && form?.startTime}
                // maxTime={new Date('2025-05-12T22:00:00')}
                />
            case 'week':
                return <AWeekPicker
                    selectedDays={form?.[col?.colKey] ?? []}
                    onChange={(week) => {
                        rowFormHandler(col?.colKey, week, setForm)
                    }}
                    disabled={action == 'new' ? false : col.disabled}
                    multiSelect={col?.isMulti}
                />
            case 'textArea':
                return <AddApplicationListPopup
                    value={form?.[col?.colKey] ?? ''}
                    handler={(value) => {
                        rowFormHandler(col?.colKey, value, setForm)
                    }}
                    viewOnly={action == 'new' ? false : col.disabled}
                />
            case 'dialoge':
                return <AButton
                    variant="link"
                    size="xs"
                    //disabled={rowForm?.applicationLevel === 'NO' || !params?.row?.isNew}
                    onClick={
                        (e) => {
                            e.stopPropagation();
                            setOpen(true)
                        }
                    }
                >
                    View
                </AButton>
            case 'checkbox':
                return <div className="d-flex" style={{ gap: "8px" }}>
                    {checkboxOptions?.map((item) => (
                        <FormControlLabel
                            key={JSON.stringify(item)}
                            disableTypography
                            sx={{ margin: "0px", ...primaryCheckboxStyles }}
                            control={
                                <Checkbox
                                    sx={{ padding: "3px" }}
                                    onChange={item?.onChange}
                                    checked={item?.checked}
                                    disabled={item?.disabled}
                                />
                            }
                            label={
                                <div
                                    className={`semi-bold ${item?.checked ? "label-color" : "color-grey-60"
                                        }`}
                                >
                                    {item?.title}
                                </div>
                            }
                        />
                    ))}
                </div>
            case 'status':
                return <StatusSyncingDropdown
                    hasUpdate={true}
                    statusValue={form?.[col?.colKey] ?? {}}
                    handler={(value) => {
                        rowFormHandler(col?.colKey, value, setForm)
                    }}
                    setAnchorEl={setAnchorEl}
                    anchorEl={anchorEl}
                />
            default:
                return <></>
        }
    }
    return (<>
        <div className='d-flex align-items-center justify-content-between'>
            <div className='mt-24 large-semi-bold label-color'> {heading}</div>
            {toggleRequired && <div className='ml-3  br-8 cursor' onClick={() => { setOpenToggle((prev) => (!prev)) }}>{openToggle ? <Uparrow /> : <DownArrow />}</div>}
        </div>
        {toggleRequired ? openToggle && <Row>
            {dataArray.map((col, index) => {
 
                return <Col md={4} className='mt-24'>
                    <div>

                        <div className='regular-small color-grey-60 mb-1'>
                            {col?.label}
                        </div>
                        <div className='large-semi-bold label-color'>
                            {
                                !isEdit ?
                                    col?.colKey == 'contactNumbers' ?
                                        <AddApplicationListPopup
                                            value={form?.[col?.colKey] ?? ''}
                                            handler={(value) => {
                                                rowFormHandler(col?.colKey, value, setForm)
                                            }}
                                            viewOnly={true}
                                        />
                                        :
                                        getFormatCol(col?.colKey == 'effectiveDate' ? moment(form?.[col?.colKey]).format('DD/MM/YYYY') : form?.[col?.colKey], col?.colKey,col?.label,col)
                                    : getVal(col, index, form, setForm)
                            }
                        </div>
                    </div>
                </Col>

            })}
        </Row> :
            <Row>
                {dataArray.map((col, index) => {
                    return <Col md={4} className='mt-24'>
                        <div>

                            <div className='regular-small color-grey-60 mb-1'>
                                {col?.label}
                            </div>
                            <div className='large-semi-bold label-color'>
                                {
                                    !isEdit ?
                                        col?.colKey == 'contactNumbers' ?
                                            <AddApplicationListPopup
                                                value={form?.[col?.colKey] ?? ''}
                                                handler={(value) => {
                                                    rowFormHandler(col?.colKey, value, setForm)
                                                }}
                                                viewOnly={true}
                                            />
                                            :
                                            getFormatCol(col?.colKey == 'effectiveDate' ? moment(form?.[col?.colKey]).format('DD/MM/YYYY') : form?.[col?.colKey], col?.colKey, col?.label,col)
                                        : getVal(col, index, form, setForm)
                                }
                            </div>
                        </div>
                    </Col>

                })}
            </Row>
        }
    </>
    )
}

export const getAuditDetails = (updatedBy, updatedOn) => {

    return <div className='color-grey-60 regular-small mt-3'>
        Last updated on {moment(updatedOn).format('DD/MM/YYYY')} at {moment(updatedOn).format('hh:mm A')} by {updatedBy}
    </div>
}

// import React, { useState } from 'react';
// import { Dialog } from '@mui/material';
// import ATextarea from '../../../common/formFeilds/customInput/ATextarea';

// import AButton from '../../../common/form-fields-mui/AButton';
// import { regex } from '../../../common/constant';

export const AddApplicationListPopup = ({
    value,
    handler: handleChange,
    viewOnly
}) => {

    // const { isOpen, viewOnly, initialPhoneNo = "" } = dialogInfo;
    const [isOpen, setOpen] = useState(false)
    const closeDialog = () => setOpen(false);
    const updateLists = (inputVal) => {
        const phoneList = inputVal.split(',').filter(val => Boolean(val));
        if (phoneList.some(el => el.length != 10)) {
            failureToast('Please enter a valid phone number')
            return
        }
        handleChange(phoneList.join(","));
        closeDialog();
    }



    return (
        <> <AButton
            variant="link"
            size="xs"
            //disabled={rowForm?.applicationLevel === 'NO' || !params?.row?.isNew}
            onClick={
                (e) => {
                    e.stopPropagation();
                    setOpen(true)
                }
            }
        >
            {viewOnly ? 'View' : value.length ? 'Edit' : 'Add'}
        </AButton>
            {isOpen && <DialogOpen
                isOpen={isOpen}
                updateLists={updateLists}
                closeDialog={closeDialog}
                value={value}
                viewOnly={viewOnly}
            />
            }
        </>
    );
}

const DialogOpen = ({
    isOpen,
    updateLists,
    closeDialog,
    value,
    viewOnly
}) => {
    const [inputVal, setInputVal] = useState(value);
    return (
        <Dialog
            open={isOpen}
            fullWidth
            maxWidth="sm"
        >
            <div className='p-3'>

                <div className='d-flex justify-content-between'>
                    <h3>Branch Phone No.</h3>
                    <CloseIcon className='cursor' onClick={closeDialog} />
                </div>

                <ATextarea
                    placeholder='Enter Phone no.'
                    onChange={val => setInputVal(val)}
                    disabled={viewOnly}
                    value={ viewOnly? maskPhoneNumber(inputVal) : inputVal}
                    //maxlength = {110}
                    regex={/^(\d+)(,(\d*)?){0,9}?$|^$/} //regex that allows maximum 10 comma separated numbers
                />

                {!viewOnly && <AButton
                    variant='primary_filled'
                    className='no-ml-btn d-block'
                    onClick={() => updateLists(inputVal)}
                    disabled={!inputVal}
                >
                    Save
                </AButton>
                }

            </div>

        </Dialog>
    )
}